@file:OptIn(ExperimentalSerializationApi::class)

package apps

import api.*
import kotlinx.serialization.*
import kotlinx.serialization.protobuf.*

@Serializable
sealed interface AppReport {
    @ProtoNumber(1)
    val appId: Long

    /** @see api.AppType */
    @ProtoNumber(2)
    val type: Int

    @ProtoNumber(3)
    val revision: Int

    @Serializable
    data class Quiz(
        @ProtoNumber(1)
        override val appId: Long = -1,
        @ProtoNumber(2)
        override val type: Int = AppType.QUIZ.type,
        @ProtoNumber(3)
        override val revision: Int,
        @ProtoNumber(4)
        var answers: List<Answer> = listOf()
    ) : AppReport {
        @Serializable
        data class Answer(
            @ProtoNumber(1)
            val questionId: Long,
            /**
             * @see App.Quiz.Question.Type
             */
            @ProtoNumber(2)
            val type: Int,
            @ProtoNumber(3)
            val single: Long = -1,
            @ProtoNumber(4)
            val multiple: List<Long> = listOf(),
            @ProtoNumber(5)
            val text: String = ""
        )
    }
}
